import { useMutation, useQueryClient } from '@tanstack/react-query'

import { userKeys } from '@/hooks/user-query-keys'
import { LogoutService } from '@/http'

export const useLogout = () => {
  const queryClient = useQueryClient()
  const mutation = useMutation({
    mutationKey: userKeys.logout(),
    mutationFn: async () => new LogoutService().execute(),
    onSuccess: () => {
      localStorage.clear()
      queryClient.clear()
    },
  })
  return mutation
}
